var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7066 5.38706C13.7066 7.51241 11.8957 9.27413 9.61304 9.27413C7.33034 9.27413 5.51953 7.51241 5.51953 5.38706C5.51953 3.26172 7.33034 1.5 9.61304 1.5C11.8957 1.5 13.7066 3.26172 13.7066 5.38706Z",
    stroke: "#005068",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55587 14.7033C2.31181 12.4601 4.66424 11.4194 7.03137 11.4194H12.1943C14.5614 11.4194 16.9139 12.4601 17.6698 14.7033C17.901 15.3893 18.0881 16.1621 18.1742 17.0013C18.2306 17.5507 17.778 18 17.2257 18H2C1.44772 18 0.995024 17.5507 1.05144 17.0013C1.13762 16.1621 1.32468 15.3893 1.55587 14.7033Z",
    stroke: "#005068",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.7b8db297ffc9ace218fbc1ee34124d64.svg";
export { ForwardRef as ReactComponent };